<script setup>
// API oficial do WhatsApp: fora da janela de 24h só template é entregue. Este aviso aparece em todo
// ponto onde dá para configurar um envio automático em texto livre, que falharia com a janela fechada.
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  text: { type: String, default: '' },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="flex items-start gap-2 p-2.5 text-xs rounded-lg bg-n-amber-3/50 text-n-amber-11"
  >
    <Icon icon="i-lucide-triangle-alert" class="size-3.5 shrink-0 mt-0.5" />
    <span>{{ text || t('WASAPI_COMMON.WINDOW_HINT') }}</span>
  </div>
</template>
